var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMonnetpay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 447.8 90",
    style: {
      enableBackground: "new 0 0 447.8 90"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000094599404377380648700000010256303361215266181_);}\n\t.st2{fill:url(#SVGID_00000046322452971408341230000007039316686311244687_);}\n\t.st3{fill:url(#SVGID_00000005965304973128057900000000830416908456631995_);}\n\t.st4{fill:url(#SVGID_00000116926225875566550370000005111193080857745061_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2147,
    y1: 253.2424,
    x2: 447.5304,
    y2: 253.2424,
    gradientTransform: "matrix(1 0 0 1 0 -208.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#395AE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E2CD1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,12.8c0.2-0.2,0.4-0.6,0.6-0.9c3-4.7,9-4.7,12-0.2c7.1,10.6,14.1,21.4,21.2,32c1.3,2.1,1.3,2.1,2.7,0.1 C50,33,57.2,22.2,64.6,11.6c2.9-4.2,7.3-4.4,10.6-0.8c0.9,1.2,1.4,2.4,1.4,3.9c0,20.2,0,40.3,0,60.5c0,3.8-2.7,6.4-6.6,6.3 c-3.8-0.1-6.6-2.7-6.6-6.4c-0.1-12.8-0.1-25.7-0.1-38.5c0-0.7,0.2-1.5-0.2-2.2c-0.8,0.2-1,0.9-1.3,1.5c-4.8,7.2-9.6,14.5-14.5,21.7 c-0.3,0.5-0.7,1.1-1.1,1.6c-3.2,4.2-8.1,4.1-11.1-0.3c-4.5-6.8-8.8-13.6-13.2-20.4c-1-1.6-2-3.2-3.2-4.9c-0.5,0.8-0.3,1.6-0.3,2.2 c0,12.4,0,24.9,0,37.2c0,1.1,0,2.2-0.2,3.3c-0.7,2.9-2.5,4.7-5.2,5.2c-2.6,0.4-5.1-1-6.4-3.6c-0.2-0.2-0.3-0.6-0.4-0.8 C6.1,55.5,6.1,34.2,6.1,12.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038414847631774636090000013155084066730546872_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2147,
    y1: 253.4,
    x2: 447.5304,
    y2: 253.4,
    gradientTransform: "matrix(1 0 0 1 0 -208.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#395AE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E2CD1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038414847631774636090000013155084066730546872_)"
    },
    d: "M128.2,7.6c4.4,0.8,8.6,2,12.5,4.3 c10.8,6.3,16.7,15.9,18.2,28.1c1.3,10.6-1.1,20.3-7.6,28.8c-6.3,8.1-14.7,12.6-25,13.5c-20.4,1.8-37-13.6-38.6-33.3 c-0.9-10.2,1.4-19.4,7.6-27.7c5.6-7.3,13-11.9,22.2-13.3c0.3-0.1,0.7-0.2,1.1-0.3C121.7,7.6,124.9,7.6,128.2,7.6z M123.8,20.3 c-9.1-0.2-15.3,4-19.2,11.6c-4.5,8.6-4.4,17.6,0,26.3c6.6,13.3,23.7,15.7,34,5c7.6-8,9.1-22.3,3.2-32.1 C137.5,24.1,131.6,20.2,123.8,20.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033355293497143857390000002011521473596039066_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2147,
    y1: 253.1324,
    x2: 447.5304,
    y2: 253.1324,
    gradientTransform: "matrix(1 0 0 1 0 -208.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#395AE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E2CD1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033355293497143857390000002011521473596039066_)"
    },
    d: "M183.6,29.4c-0.5,0.7-0.3,1.5-0.3,2.2 c0,14.1,0,28.3,0,42.4c0,2.6-0.9,4.7-3.2,5.9c-2.2,1.2-4.6,1.2-6.7-0.2c-2-1.2-2.8-3.2-2.8-5.6c0-9.1,0-18.1,0-27.2 c0-10.4,0.1-20.7-0.1-31.1c0-3.1,0.9-5.4,3.7-6.7c2.9-1.3,5.3-0.4,7.6,1.6c9.3,8.2,18.6,16.5,27.8,24.7c9.1,8,18,16,27,23.9 c0.2,0.2,0.5,0.4,0.8,0.3c0-1.7,0-3.6,0-5.3c-0.2-11.2-0.3-22.5-0.5-33.7c-0.1-1.7-0.2-3.5-0.2-5.2c0-2.7,1.1-5,3.7-6.2 c2.6-1.2,5-0.7,7.1,1.1c4.5,3.9,8.8,7.9,13.2,11.9C272,32.4,283.4,42.7,294.8,53c2.2,1.9,4.2,3.9,6.3,5.8c0.4,0.3,0.7,1.1,1.3,0.7 c0.6-0.3,0.3-1,0.3-1.6c0.2-12.5,0.3-24.9,0.5-37.4c0.1-2.1,0.2-4.1,0.2-6.2c0.2-3.1,2.7-5.5,6-5.9c2.6-0.3,5.7,1.8,6.4,4.5 c0.4,1.5,0.5,3,0.4,4.5c-0.5,9.1-0.1,18.3-0.4,27.3c-0.4,9.6-0.2,19.1-0.3,28.7c-0.2,5.7-4.6,8.9-9.2,6.8c-1.3-0.6-2.3-1.7-3.4-2.7 c-9.8-8.9-19.6-17.8-29.4-26.7c-7.6-6.8-15.1-13.7-22.8-20.6c-0.2-0.2-0.4-0.5-0.9-0.3c0,2.3-0.2,4.8,0.1,7.2 c0.2,2.7,0.2,5.5,0.2,8.2c0.2,9.4,0.2,18.9,0.5,28.3c0.1,2.9-0.9,5.2-3.6,6.5c-2.7,1.2-5.2,0.7-7.5-1.2C232.8,73,226,67,219.2,61 c-10.3-9.1-20.4-18.3-30.7-27.3C187,32.2,185.5,30.5,183.6,29.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075130506137063323700000012412716535135710874_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2147,
    y1: 253.3184,
    x2: 447.5304,
    y2: 253.3184,
    gradientTransform: "matrix(1 0 0 1 0 -208.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#395AE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E2CD1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075130506137063323700000012412716535135710874_)"
    },
    d: "M327.3,45c0-9.6,0-19.1,0-28.7 c0-5.4,2.4-7.9,7.9-7.9c7.2-0.1,14.5,0,21.7,0c3.8,0,7.7-0.1,11.6,0c4.1,0.1,6.9,2.4,7.2,5.7c0.3,3.8-2.4,6.6-6.8,6.6 c-8.3,0.1-16.7,0-25.1,0c-0.6,0-1.1,0-1.7,0c-0.8,0-1.2,0.5-1.2,1.2c0,4.8,0,9.6,0,14.5c0,1.5,1.1,1.5,2.1,1.5c6.6,0,13.4,0,20,0 c1.1,0,2.2,0.1,3.3,0.3c2.9,0.7,4.6,3,4.6,6.1c0,2.9-1.6,4.8-4.5,5.7c-1,0.3-2.1,0.3-3.2,0.3c-6.6,0-13.4,0.1-20-0.1 c-1.7,0-2.4,0.4-2.4,2.3c0.2,4.7,0.1,9.5,0,14.2c-0.1,1.7,0.6,2.2,2.3,2.2c8.2-0.1,16.5-0.1,24.7-0.1c1.9,0,3.7,0.2,5.3,1.4 c2.2,1.7,3,4,2.3,6.4c-0.7,2.5-2.9,4.3-5.8,4.5c-1.7,0.2-3.2,0.1-4.9,0.1c-10,0-19.9,0-29.9,0c-5.1,0-7.6-2.5-7.6-7.6 C327.3,64.2,327.3,54.5,327.3,45z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107561830540519494630000017018840240189482648_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2147,
    y1: 253.2407,
    x2: 447.5304,
    y2: 253.2407,
    gradientTransform: "matrix(1 0 0 1 0 -208.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#395AE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E2CD1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107561830540519494630000017018840240189482648_)"
    },
    d: "M404.9,48.8c0-8.6-0.1-17.2,0.1-25.8 c0-1.7-0.6-2.2-2.2-2.2c-4.7,0.1-9.5,0.1-14.2,0c-4.6-0.1-7.5-3.7-6.4-7.9c0.7-2.3,2.3-3.7,4.6-4.2c1.2-0.2,2.3-0.3,3.5-0.3 c14.5-0.1,28.9,0,43.4,0c1.2,0,2.3,0.1,3.5,0.4c2.8,0.8,4.6,3.1,4.6,5.9c0,2.9-1.7,5-4.7,5.8c-0.9,0.2-1.8,0.3-2.7,0.3 c-4.2,0-8.3,0-12.6,0c-2.9,0-2.9,0-2.9,2.8c0,16.8,0,33.6,0,50.4c0,4.2-2.1,6.6-6,7.3c-4.4,0.7-8-2.2-8-6.6 C404.9,66,404.9,57.4,404.9,48.8z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMonnetpay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/monnetpay.6c0931cc0e9797301ab8728787e612d0.svg";